module.exports = __webpack_public_path__ + "img/reserved-parking.ee3d4469.png";